import { CHANGE_SITE_INFO } from "../constants/actionTypes";
import initialState from "./initialState";

export default function siteInfoReducer(state = initialState.siteInfo, action) {
  switch (action.type) {
    case CHANGE_SITE_INFO:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}